import React from "react";
import "../../pages/style.css";
import { Container } from "react-bootstrap";

function Contactpage() {
  return (
    <div className="contactbackground">
      <Container>
        <h2 className="contacthead">Get In Touch</h2>
        <p className="contactpara">
          {" "}
          I’m currently searching for opportunities for a Full Stack Developer /
          Software Developer role. <br /> If there is any vacancy my inbox is
          always open. Whether <br /> you have any further questions or just
          want to say hi, <br /> I’ll try my best to get back to you!
        </p>
        <button
          className="contactbtn"
          onClick={() => {
            window.open("https://wa.me/+919771123759");
          }}
        >
          Say Hello
        </button>
        <span></span>
        <hr className="line" />
        <p className="copyright">
          © Copyright 2024.
          <br />
          Designed & Built by <span>@nmol</span>
        </p>
      </Container>
    </div>
  );
}

export default Contactpage;
